var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-full relative"},[_c('div',{style:({height : '35px', width : '150px'})},[_c('canvas',{ref:"chartCanvas"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }